import {isLockedStatus} from '../../../projects/services/ParentStatusService';
import {TaskStatus} from '../../../tasks/enums/TaskStatus';


export function canAddFile(status) {
  switch (status) {
    case 'pending':
    case 'in_progress':
    case 'submitted':
    case 'rejected':
      return 'requirement_submission_edit';
    case 'approved':
      return 'requirement_approval_edit';
    case 'cancelled':
    default:
      return null
  }
}

export function canAddAssetFile(status) {
  return `asset_${canAddFile(status)}`;
}

/**
 * @param permissionsData
 * @param taskType
 * @return {Object<String, Boolean>} Map of status to hasPermission
 */
export function calcUploadFileByStatus(permissionsData, taskType) {
  return Object.values(TaskStatus)
    .reduce((acc, status) => {
      acc[status] = checkCanAddFile(permissionsData.hasPermission, permissionsData.roleData, status, taskType);
      return acc;
    }, {});
}

export function checkCanAddFile(hasPermission, roleData, reqStatus, taskType) {
  if (!hasPermission || !roleData) {
    return true;

  } else {
    const permission = taskType
      ? getCanAddAssetFilePermission(roleData, reqStatus)
      : getCanAddProjectFilePermission(roleData, reqStatus);
    return hasPermission(permission);

  }
}

function getCanAddProjectFilePermission(roleData, reqStatus) {
  const isLocked = roleData.projectIsLocked || roleData.taskIsLocked || isLockedStatus(reqStatus);
  return isLocked ? canAddFile(reqStatus) + '_locked' : canAddFile(reqStatus);
}

function getCanAddAssetFilePermission(roleData, reqStatus) {
  const isLocked = roleData.projectIsLocked
    || roleData.assetProjectIsLocked
    || roleData.assetTaskIsLocked
    || isLockedStatus(reqStatus);
  return isLocked ? canAddAssetFile(reqStatus) + '_locked' : canAddAssetFile(reqStatus);
}



// WEBPACK FOOTER //
// ./src/js/requirements/domain/files/utils.js